import { getApiUserManagementV1OperatorPermissions } from '@/libs/api-user-mgt/umOpenApiGaps/operatorPermissionsNotInOpenApiClient';

export interface OperatorPermissionsResult {
  featureKeys: string[];
  toolRoleName: string | null;
  isReadOnlyOperator: boolean;
  allDatabases: boolean;
  databaseNames: string[];
  scopeLabel: string;
}

export const userManagementAuthSegment = {
  getOperatorPermissions: async (): Promise<OperatorPermissionsResult> => {
    const response = await getApiUserManagementV1OperatorPermissions();
    const payload = response.data ?? {};
    const keys = Array.isArray(payload.featureKeys) ? payload.featureKeys : [];
    const toolRoleName =
      typeof payload.toolRoleName === 'string' && payload.toolRoleName.trim() !== '' ? payload.toolRoleName.trim() : null;
    const databaseNames = Array.isArray(payload.databaseNames)
      ? payload.databaseNames.filter((name): name is string => typeof name === 'string')
      : [];
    const allDatabases = payload.allDatabases !== false;
    return {
      featureKeys: keys.filter((key): key is string => typeof key === 'string' && key.trim() !== ''),
      toolRoleName,
      isReadOnlyOperator: Boolean(payload.isReadOnlyOperator ?? payload.IsReadOnlyOperator ?? false),
      allDatabases,
      databaseNames,
      scopeLabel:
        typeof payload.scopeLabel === 'string' && payload.scopeLabel.trim() !== ''
          ? payload.scopeLabel
          : allDatabases
            ? 'All databases'
            : databaseNames.join(', ')
    };
  }
};
